import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { AlertService } from '../components/alert/alert.service'
import { LoadingService } from '../components/loading/loading.service'
import { AuthService } from '../services/auth.service'

export function accessTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	let nextRequest = req
	const authService = inject(AuthService)
	const alertService = inject(AlertService)
	const loadingService = inject(LoadingService)
	const translateService = inject(TranslateService)
	const accessToken = authService.getAccessToken()

	if (accessToken) {
		nextRequest = req.clone({
			headers: req.headers.append('Authorization', `Bearer ${accessToken}`).append('Content-Type', 'application/json'),
			params: translateService.currentLang ? req.params.set('locale', translateService.currentLang) : req.params,
		})
	}

	return next(nextRequest).pipe(
		catchError((err) => {
			if (req.headers.has('Refresh-Token')) {
				authService.logOut()
			} else if (err instanceof HttpErrorResponse && err.status === 401 && !req.url.includes('logout') && !req.url.includes('user_login')) {
				loadingService.closeLoading().then(() =>
					alertService.showAlert(
						'Click "OK" to renew session',
						() => authService.refreshToken(),
						() => authService.logOut(),
					),
				)
			}

			return throwError(() => err)
		}),
	)
}
